import { useReportBackendApiPath } from 'Pages/ReportsAlerts/Reports/@hooks'
import { useSignal, batch, useComputed } from '@preact/signals-react'
import { useEffect, useCallback } from 'react'
import { getSubmit } from '@ui-seeker/utils'
import { TIME_OUT_STATUS } from '@constants'
import { reportSearchesModalId } from '@signals'

export default function useReportSearchesModalData(idReport, isRunning, isExtras) {
	const { searchesUrl, searchesBySiteUrl, reportType } = useReportBackendApiPath(isExtras)
	const areSummariesLoading = useSignal(false)
	const sitesData = useSignal({})
	const officesData = useSignal({})
	const TOTAL_SEARCHES_PERCENTAGE = 100
	const isFinished = useComputed(() => officesData.value?.completedPercentage === TOTAL_SEARCHES_PERCENTAGE && sitesData.value?.completedPercentage === TOTAL_SEARCHES_PERCENTAGE)
	const key = reportType !== 'batch' ? 'idReportExecution' : 'idBatch'

	useEffect(() => {
		areSummariesLoading.value = true
		fetchSearchSummaries()
	}, [])


	const fetchSearchSummaries = useCallback(() => {
		if (!isRunning || !reportSearchesModalId.value) return

		Promise.all([
			getSubmit(searchesBySiteUrl, { [key]: idReport }),
			getSubmit(searchesUrl, { [key]: idReport, perOffice: true }),
		])
			.then(([{ statusData: statusSites, ids: sitesIds, globalData: globalSitesData }, { statusData: statusOffices, ids: officesIds, globalData: globalOfficesData }]) => {
				batch(() => {
					sitesData.value = {
						completedPercentage: globalSitesData?.percentage,
						totalPercentage: 100,
						sitesInfo: sitesIds.map(name => {
							const { percentage, nameSite, marketSite, iconSite } = statusSites[name]
							return {
								name: nameSite,
								market: marketSite,
								current: percentage,
								icon: iconSite,
								total: 100,
							}
						}),
					}
					officesData.value = {
						completedPercentage: globalOfficesData?.percentage,
						totalPercentage: 100,
						officesInfo: officesIds.map(id => {
							const { percentage, nameOffice, countryOffice, typeOffice } = statusOffices[id]
							return {
								name: nameOffice,
								country: countryOffice,
								current: percentage,
								type: typeOffice,
								total: 100,
							}
						}),
					}
					areSummariesLoading.value = false
				})
			})
			.finally(() => {
				if (reportSearchesModalId.value && !isFinished.value) {
					setTimeout(fetchSearchSummaries, TIME_OUT_STATUS)
				} else {
					reportSearchesModalId.value = null
				}
			})
	}, [isRunning, idReport, searchesUrl, searchesBySiteUrl, isFinished.value])

	return {
		sitesData: sitesData.value,
		officesData: officesData.value,
		areSummariesLoading: areSummariesLoading.value,
	}
}